// extracted by mini-css-extract-plugin
export default {"input":"checkbox_input__iPOc6","inputContainer":"checkbox_inputContainer__ychJF","label":"checkbox_label__QGmEb"};